import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import BlogDetail from "../components/Blog/BlogDetail";
import RelatedBlogs from "../components/Blog/RelatedBlogs";
import Loading from "../components/UI/Loading";
import { fetchBlog } from "../features/blog/blogSlice";

const Post = () => {
  const { blog, isLoading, isError, error } = useSelector(
    (state) => state.blog
  );

  const dispatch = useDispatch();
  const { blogId } = useParams();

  useEffect(() => {
    dispatch(fetchBlog(blogId));
  }, [dispatch, blogId]);

  let content = null;
  if (isLoading) content = <Loading />;
  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError & !blog?.id)
    content = <div className="col-span-12">No Blog Found!</div>;

  if (!isLoading && !isError && blog?.id)
    content = (
      <section className="post-page-container">
        <BlogDetail blog={blog} />
        <RelatedBlogs currentBlogId={blog.id} tags={blog.tags} />
      </section>
    );
  return (
    <>
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
        {content}
      </div>
    </>
  );
};

export default Post;
